var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-navbar-brand',{attrs:{"to":"/"}},[_c('img',{staticClass:"d-inline-block align-top",attrs:{"src":require("@/assets/logo_eterna.svg"),"alt":"Eterna"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }